/*
  custom-dropship-consent.js (2026-10-02 追加)
  AliExpress 直送商品（商品メタフィールド custom.dropship_aliexpress）がカートにあるとき、
  カートで海外への個人データ提供の同意を取り、カート属性に記録する。同意のないまま決済へ進む導線を止める。
  - 判定: /cart?view=custom-dropship（templates/cart.custom-dropship.liquid）の JSON
  - 同意欄: snippets/custom-dropship-consent.liquid（カートページのフッター）
  - 公開: window.customDropship.check() / goCheckout(url)
  記録: CUSTOM_DROPSHIP_CONSENT_CHANGES.md
*/
(function () {
  if (window.customDropship) return;

  var routesObj = window.routes || {};
  var CART_URL = routesObj.cart_url || '/cart';
  var UPDATE_URL = (routesObj.cart_update_url || '/cart/update') + '.js';
  var ENDPOINT = CART_URL + '?view=custom-dropship';
  var REQUIRED_URL = CART_URL + '?consent=required';
  var PENDING_KEY = 'customDsRevokePending';

  var storageOk = (function () {
    try {
      sessionStorage.setItem('__cds', '1');
      sessionStorage.removeItem('__cds');
      return true;
    } catch (e) {
      return false;
    }
  })();
  var memoryPending = false;

  function getPending() {
    if (storageOk) {
      try {
        return sessionStorage.getItem(PENDING_KEY) === '1';
      } catch (e) {}
    }
    return memoryPending;
  }

  function setPending(value) {
    memoryPending = value;
    if (!storageOk) return;
    try {
      if (value) sessionStorage.setItem(PENDING_KEY, '1');
      else sessionStorage.removeItem(PENDING_KEY);
    } catch (e) {}
  }

  var generation = 0;

  function check() {
    var gen = ++generation;
    return fetch(ENDPOINT + '&_=' + Date.now(), {
      credentials: 'same-origin',
      cache: 'no-store',
    })
      .then(function (res) {
        // Accept: application/json を付けると Shopify は代替テンプレートでなくカートの JSON を返すので付けない
        if (!res.ok) throw new Error('custom-dropship: status ' + res.status);
        return res.json();
      })
      .then(function (d) {
        if (!d || typeof d.has_dropship !== 'boolean' || !Array.isArray(d.keys) || typeof d.current_version !== 'string' || !d.current_version) {
          throw new Error('custom-dropship: unexpected response');
        }
        var stored = d.consent === 'yes' && d.version === d.current_version;
        return {
          stale: gen !== generation,
          hasDropship: d.has_dropship,
          keys: d.keys,
          rawConsent: d.consent === 'yes',
          consented: stored && !getPending(),
          currentVersion: d.current_version,
        };
      });
  }

  function goCheckout(url) {
    return check()
      .then(function (s) {
        if (s.hasDropship && !s.consented) window.location.href = REQUIRED_URL;
        else window.location.href = url;
      })
      .catch(function () {
        window.location.href = CART_URL;
      });
  }

  function writeAttributes(attrs) {
    return fetch(UPDATE_URL, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: attrs }),
    }).then(function (res) {
      if (!res.ok) throw new Error('custom-dropship: update ' + res.status);
      return res.json();
    });
  }

  var queue = Promise.resolve();
  function enqueue(task) {
    var run = queue.then(task, task);
    queue = run.catch(function () {});
    return run;
  }

  function revoke() {
    return enqueue(function () {
      return writeAttributes({ dropship_consent: '', dropship_consent_version: '', dropship_consent_at: '' }).then(function (cart) {
        var attrs = (cart && cart.attributes) || {};
        if (attrs.dropship_consent === 'yes') throw new Error('custom-dropship: revoke not applied');
        setPending(false);
        return true;
      });
    });
  }

  function grant(version) {
    return enqueue(function () {
      return writeAttributes({
        dropship_consent: 'yes',
        dropship_consent_version: version,
        dropship_consent_at: new Date().toISOString(),
      }).then(function (cart) {
        var attrs = (cart && cart.attributes) || {};
        if (attrs.dropship_consent !== 'yes' || attrs.dropship_consent_version !== version) {
          throw new Error('custom-dropship: consent not applied');
        }
        return true;
      });
    });
  }

  /* ---------- 送信ガード（カート通知・カートページ） ---------- */

  var guarding = false;

  document.addEventListener(
    'submit',
    function (event) {
      var form = event.target;
      var submitter = event.submitter;
      if (!form || !submitter || submitter.name !== 'checkout') return;
      if (form.dataset.cdsPass === '1') {
        delete form.dataset.cdsPass;
        return;
      }
      event.preventDefault();
      if (guarding) return;
      if (cartPage.active && (cartPage.busy || cartPage.blocked())) {
        cartPage.showRequired();
        return;
      }
      guarding = true;
      check()
        .then(function (s) {
          guarding = false;
          if (s.hasDropship && !s.consented) {
            if (cartPage.active && cartPage.box()) cartPage.showRequired();
            else window.location.href = REQUIRED_URL;
            return;
          }
          form.dataset.cdsPass = '1';
          if (typeof form.requestSubmit === 'function') {
            form.requestSubmit(submitter);
          } else {
            var hidden = form.querySelector('input[type="hidden"][name="checkout"]');
            if (!hidden) {
              hidden = document.createElement('input');
              hidden.type = 'hidden';
              hidden.name = 'checkout';
              hidden.value = submitter.value || '';
              form.appendChild(hidden);
            }
            delete form.dataset.cdsPass;
            form.submit();
          }
        })
        .catch(function () {
          guarding = false;
          window.location.href = CART_URL;
        });
    },
    true
  );

  /* ---------- カートページの同意欄 ---------- */

  var cartPage = {
    active: false,
    busy: false,
    saved: false,
    initialHasDropship: false,
    initialKeys: '',
    box: function () {
      return document.getElementById('CustomDsConsent');
    },
    checkbox: function () {
      return document.getElementById('CustomDsConsentCheckbox');
    },
    button: function () {
      return document.getElementById('checkout');
    },
    blocked: function () {
      if (!this.box()) return false;
      var cb = this.checkbox();
      return !(cb && cb.checked && this.saved && !getPending());
    },
    setText: function (id, text) {
      var el = document.getElementById(id);
      if (!el) return;
      el.textContent = text || '';
      if (el.getAttribute('role') === 'alert') el.hidden = !text;
    },
    render: function () {
      var box = this.box();
      if (!box) return;
      var cb = this.checkbox();
      var hint = document.getElementById('CustomDsConsentHint');
      var btn = this.button();
      var blocked = this.blocked();
      if (cb) cb.disabled = this.busy;
      box.setAttribute('aria-busy', this.busy ? 'true' : 'false');
      if (hint) hint.hidden = !blocked;
      if (btn) {
        var empty = !!document.querySelector('#main-cart-footer.is-empty');
        btn.disabled = this.busy || blocked || empty;
      }
    },
    showRequired: function () {
      var notice = document.getElementById('CustomDsConsentRequired');
      var title = document.getElementById('CustomDsConsentTitle');
      if (notice) notice.hidden = false;
      if (title) {
        title.scrollIntoView({ block: 'center' });
        title.focus({ preventScroll: true });
      }
    },
    onToggle: function (cb) {
      var self = this;
      var box = this.box();
      if (!box || this.busy) return;
      var want = cb.checked;
      var version = box.dataset.version;
      this.busy = true;
      this.saved = false;
      this.setText('CustomDsConsentError', '');
      this.setText('CustomDsConsentStatus', '保存しています…');
      if (!want) setPending(true);
      this.render();
      var task = want ? grant(version) : revoke();
      task
        .then(function () {
          self.busy = false;
          self.saved = want;
          self.setText('CustomDsConsentStatus', want ? '同意を保存しました。' : '同意を取り消しました。');
          self.render();
        })
        .catch(function () {
          self.busy = false;
          self.saved = false;
          self.setText('CustomDsConsentStatus', '');
          if (want) {
            cb.checked = false;
            self.setText('CustomDsConsentError', '同意を保存できませんでした。通信状態を確かめて、もう一度チェックしてください。');
          } else {
            self.setText('CustomDsConsentError', '同意の取り消しを保存できませんでした。通信が戻ると自動でやり直します。');
          }
          self.render();
        });
    },
    retryRevoke: function () {
      if (!getPending()) return Promise.resolve();
      var self = this;
      return revoke()
        .then(function () {
          self.setText('CustomDsConsentError', '');
          self.setText('CustomDsConsentStatus', '同意を取り消しました。');
        })
        .catch(function () {});
    },
    sync: function () {
      var self = this;
      if (this.busy) return;
      this.retryRevoke()
        .then(function () {
          return check();
        })
        .then(function (s) {
          if (s.stale) return;
          var keys = s.keys.join(',') + (s.keys.length ? ',' : '');
          var changed = s.hasDropship !== self.initialHasDropship || (s.hasDropship && keys !== self.initialKeys);
          if (!s.hasDropship && s.rawConsent) {
            return revoke()
              .catch(function () {})
              .then(function () {
                if (getPending() && !storageOk) return;
                window.location.reload();
              });
          }
          if (changed) {
            if (getPending() && !storageOk) return;
            window.location.reload();
            return;
          }
          var cb = self.checkbox();
          self.saved = s.consented;
          if (cb) cb.checked = s.consented;
          self.render();
        })
        .catch(function () {
          self.saved = false;
          self.render();
        });
    },
    init: function () {
      if (!document.getElementById('main-cart-footer')) return;
      var self = this;
      this.active = true;
      var box = this.box();
      this.initialHasDropship = !!box;
      this.initialKeys = box ? box.dataset.keys || '' : '';
      if (box) {
        this.saved = box.dataset.consented === 'true' && !getPending();
        var cb = this.checkbox();
        if (cb && getPending()) cb.checked = false;
        this.render();
        if (getPending()) this.sync();
        var params = new URLSearchParams(window.location.search);
        if (params.get('consent') === 'required') this.showRequired();
      } else if (getPending()) {
        this.retryRevoke();
      }

      document.addEventListener('change', function (event) {
        if (event.target && event.target.id === 'CustomDsConsentCheckbox') self.onToggle(event.target);
      });

      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
          self.sync();
        });
      }

      window.addEventListener('online', function () {
        self.sync();
      });
    },
  };

  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    guarding = false;
    document.querySelectorAll('form[data-cds-pass]').forEach(function (form) {
      delete form.dataset.cdsPass;
    });
    if (cartPage.active) {
      cartPage.busy = false;
      cartPage.sync();
    }
  });

  window.customDropship = { check: check, goCheckout: goCheckout };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      cartPage.init();
    });
  } else {
    cartPage.init();
  }
})();
